import { gql } from '@apollo/client';

const GET_SELECT_RETURN_LOCATION_PAGE_DATA = gql`
  query GetSelectReturnLocationDataWOAuth(
    $storeId: ID!
    $orderId: ID!
    $zipCode: String
    $buildTemplatedEmailHtml: Boolean
  ) {
    devolutionPageConfigs: getDevolutionPageConfigsWOAuth(storeId: $storeId) {
      __typename
      ... on GetDevolutionPageConfigsSuccess {
        code
        configs {
          backgroundColor
          headerFooterColor
          primaryColor
          secondaryColor
          fontColor
          fontColorSecondary
          footerIconsColor
          fontFamily
          logoUrl
          faviconUrl
          mainImageUrl
          instagramAccount
          facebookAccount
          linkedinAccount
          tiktokAccount
          contactEmail
          link1Title
          link1Url
          link2Title
          link2Url
        }
      }
      ... on Error {
        code
        message
      }
    }
    storeConfigs: getStoreConfigs(storeId: $storeId) {
      __typename
      ... on GetStoreConfigsSuccess {
        code
        storeConfigs {
          autoApproveDevolution
        }
      }
      ... on Error {
        code
        message
      }
    }
    order: getOrderWOAuth(
      encOrderId: $orderId
      buildTemplatedEmailHtml: $buildTemplatedEmailHtml
    ) {
      __typename
      ... on ReadOrderSuccess {
        code
        order {
          code
          status {
            id
            index
          }
          orderDate
          itemCount
          externalOrderCode
          expirationDate
          client {
            name
            email
          }
          items {
            id
            name
            price
            quantity
          }
          returnMethod {
            index
            info {
              ... on CliqueRetireOrderInfo {
                expressNumber
                boxCode
                cliqueRetireOrderId
                qrCodeUrl
                orderApprovedTemplateEmailHtml
              }
              ... on CorreiosOrderInfo {
                correiosObjectTag
                correiosPostageNumber
              }
            }
          }
        }
      }
      ... on Error {
        code
        message
      }
    }
    lockersInfo: getCliqueRetireLockersInfo(
      zipCode: $zipCode
      storeId: $storeId
    ) {
      ... on GetLockersInfoSuccess {
        code
        lockersInfo {
          boxCode
          name
          reference
          zipCode
          state
          city
          district
          street
          number
          lat
          lng
          images {
            url
            description
          }
          businessHours {
            day
            start
            end
          }
          compartimentType {
            type
            width
            height
            depth
          }
        }
      }
    }
    integrationStatus: getIntegrationsStatus(storeId: $storeId) {
      __typename
      ... on GetIntegrationsStatusSuccess {
        code
        status {
          correios
        }
      }
      ... on Error {
        message
        code
      }
    }
  }
`;

const SET_CR_RETURN_METHOD = gql`
  mutation SetCliqueRetireReturnMethod($encOrderId: ID!, $boxCode: String!) {
    setCliqueRetireReturnMethod(encOrderId: $encOrderId, boxCode: $boxCode) {
      __typename
      ... on SetCliqueRetireReturnMethodSuccess {
        code
        message
      }
      ... on Error {
        code
        message
      }
    }
  }
`;

const SET_CORREIOS_RETURN_METHOD = gql`
  mutation SetCorreiosReturnMethod($encOrderId: ID!) {
    setCorreiosReturnMethod(encOrderId: $encOrderId) {
      __typename
      ... on SetCorreiosReturnMethodSuccess {
        code
        message
      }
      ... on Error {
        code
        message
      }
    }
  }
`;

const APPROVE_OR_REJECT_ORDER = gql`
  mutation ApproveOrRejectOrder($orderId: ID!, $choice: Boolean!) {
    approveOrRejectOrder(orderId: $orderId, choice: $choice) {
      ... on ApproveOrRejectOrderSuccess {
        code
        message
        data {
          ... on ApprovedCliqueRetireOrderInfo {
            expressNumber
            qrCodeUrl
            selectedLockerAddress
            orderApprovedTemplateEmailHtml
          }
          ... on ApprovedCorreiosOrderInfo {
            correiosPostageNumber
          }
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`;

const GET_STORE_ID_BY_STORE_NAME_ID = gql`
  query GetStoreByStoreNameId($storeNameId: ID!) {
    getStoreByStoreNameId(storeNameId: $storeNameId) {
      ... on GetStoreByStoreNameIdSuccess {
        code
        store {
          id
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`;

const GET_LOCKERS_INFO = gql`
  query GetLockersInfo($zipCode: String, $storeId: ID) {
    getCliqueRetireLockersInfo(zipCode: $zipCode, storeId: $storeId) {
      ... on GetLockersInfoSuccess {
        code
        lockersInfo {
          boxCode
          name
          reference
          zipCode
          state
          city
          district
          street
          number
          lat
          lng
          images {
            url
            description
          }
          businessHours {
            day
            start
            end
          }
          compartimentType {
            type
            width
            height
            depth
          }
        }
      }
    }
  }
`;

export default {
  GET_SELECT_RETURN_LOCATION_PAGE_DATA,
  SET_CR_RETURN_METHOD,
  SET_CORREIOS_RETURN_METHOD,
  APPROVE_OR_REJECT_ORDER,
  GET_STORE_ID_BY_STORE_NAME_ID,
  GET_LOCKERS_INFO,
};
